module.exports = __webpack_public_path__ + "static/img/sangdi.349b1af3.png";